import { Component, OnInit } from '@angular/core';
import { COMPLIANCE, PRIVACY_POLICY, TERMS_OF_USE } from 'src/app/core/constants/links';
import { FooterService } from 'src/app/core/services/footer.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'th-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  currentYear: number;
  releaseNumber: string;

  termsOfUseLink: string = TERMS_OF_USE;
  privacyPolicyLink: string = PRIVACY_POLICY;
  complianceLink: string = COMPLIANCE;

  constructor(
    private footerService: FooterService,
    public authService: AuthService
  ) {}

  ngOnInit() {
    this.currentYear = new Date().getFullYear();

    this.getReleaseNumber();
  }

  getReleaseNumber() {
    this.footerService.getReleaseNumber().subscribe((releaseNumber) => {
      this.releaseNumber = releaseNumber;
    });
  }
}
